(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-addon-guard"] && !Shopify.designMode) return;
  try {
    // cart-addon-guard — clamp add-on qty to 1; remove orphaned add-ons.
  (function () {
    if (window.__sbCartGuard) return;
    window.__sbCartGuard = true;

    var ADDON_SKUS = ['EXSHIP', 'INSTRUMENTALSONG', 'SOUNDBOX-ADDON', 'PLAQUE-ADDON']; /* ADR-085: keepsake add-ons ride on a song too */
    var busy = false;

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function swap(destSelector, html, srcSelector) {
      if (!html) return;
      var dest = document.querySelector(destSelector);
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(srcSelector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    }

    function showNote(text) {
      var host = document.querySelector('cart-drawer .drawer__contents') || document.querySelector('#main-cart-items .js-contents');
      if (!host || host.querySelector('.cart-guard-note')) return;
      var p = document.createElement('p');
      p.className = 'cart-guard-note';
      p.setAttribute('role', 'status');
      p.textContent = text;
      host.insertBefore(p, host.firstChild);
    }

    function rerender(res, orphaned) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(res);
      } else if (res.sections) {
        swap('#main-cart-items .js-contents', res.sections['main-cart-items'], '.js-contents');
        swap('#main-cart-footer .js-contents', res.sections['main-cart-footer'], '.js-contents');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections['cart-icon-bubble']) {
          var nb = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (nb) bubble.innerHTML = nb.innerHTML;
        }
      }
      if (orphaned) showNote('Add-ons removed — they apply to a song in your cart.');
    }

    function run() {
      if (busy) return;
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var hasParent = cart.items.some(function (i) { return ADDON_SKUS.indexOf(i.sku) === -1; });
          var updates = {};
          var changed = false;
          var orphaned = false;
          cart.items.forEach(function (i) {
            if (ADDON_SKUS.indexOf(i.sku) === -1) return;
            var want = hasParent ? Math.min(i.quantity, 1) : 0;
            if (want !== i.quantity) {
              updates[i.variant_id] = want;
              changed = true;
              if (want === 0) orphaned = true;
            }
          });
          if (!changed) return;

          var drawer = document.querySelector('cart-drawer');
          var sections;
          if (drawer && typeof drawer.getSectionsToRender === 'function') {
            sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          } else {
            sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
          }

          busy = true;
          return fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates, sections: sections, sections_url: window.location.pathname }),
          })
            .then(function (r) { return r.json(); })
            .then(function (res) { if (res && !res.status) rerender(res, orphaned); })
            .catch(function () {})
            .then(function () { busy = false; });
        })
        .catch(function () {});
    }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);

    // Dawn publishes cart updates through its pubsub — react to song removals etc.
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(run, 50); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-addon-upsell"] && !Shopify.designMode) return;
  try {
    // cart-addon-upsell — add an add-on without leaving the cart, then refresh in place.
  (function () {
    if (window.__sbCartUpsell) return;
    window.__sbCartUpsell = true;

    function root() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function swap(destSelector, html, srcSelector) {
      if (!html) return;
      var dest = document.querySelector(destSelector);
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(srcSelector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    }

    function addAddon(id, btn) {
      var drawer = document.querySelector('cart-drawer');
      var onPage = document.getElementById('main-cart-items');
      var sections;
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      } else {
        sections = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'];
      }

      var body = {
        items: [{ id: id, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      };

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || res.status) return; // 422 etc.
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(res);
          } else if (onPage && res.sections) {
            swap('#main-cart-items .js-contents', res.sections['main-cart-items'], '.js-contents');
            swap('#main-cart-footer .js-contents', res.sections['main-cart-footer'], '.js-contents');
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble && res.sections['cart-icon-bubble']) {
              var newBubble = new DOMParser()
                .parseFromString(res.sections['cart-icon-bubble'], 'text/html')
                .querySelector('.shopify-section');
              if (newBubble) bubble.innerHTML = newBubble.innerHTML;
            }
          }
        })
        .catch(function () {})
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.cart-upsell__add') : null;
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      addAddon(id, btn);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-brief"] && !Shopify.designMode) return;
  try {
    // song-brief — one behavior for every .sb-brief on the page. Idempotent.
  // Adaptive prompts + context pre-fill + voice (attach/record); exposes an API
  // (validate/collect/getVoice) on each [data-song-brief] root for the host's
  // add-to-cart. No pricing or cart logic lives here.
  (function () {
    if (window.__sbBriefInit) return;
    window.__sbBriefInit = true;

    var REL = {
      partner:{memory:"the night we met at Dani’s party",like:"goofy, kind, always cold",detail:"our spot — the corner booth at Joe’s",mean:"my person, my calm"},
      spouse:{memory:"our first dance at the lake house",like:"stubborn, generous, terrible at cards",detail:"we say ‘see ya, see ya bye’",mean:"25 years — still my best friend"},
      parent:{memory:"Sunday pancakes, her humming in the kitchen",like:"fierce, funny, never sits still",detail:"always says ‘OMG’",mean:"she raised me twice"},
      child:{memory:"the day she was born — tiny and loud",like:"curious, brave, obsessed with dinosaurs",detail:"we call him Bug",mean:"my whole heart"},
      friend:{memory:"that road trip we still laugh about",like:"loyal, blunt, the planner",detail:"inside joke: ‘the goose incident’",mean:"my ride-or-die for 15 years"},
      pet:{memory:"the day we brought her home from the shelter",like:"steals socks, naps in sunbeams",detail:"we call her Bean",mean:"got me through a hard year"},
      memorial:{memory:"long porch talks, his old guitar",like:"gentle, stubborn, always singing",detail:"signed every note ‘love, Pop’",mean:"the man who taught me everything"},
      other:{memory:"a moment that says who they are",like:"their quirks — what they always do",detail:"a nickname or inside joke",mean:"why they matter to you"}
    };
    var QMAP = {
      spouse:["How did you two meet?","What do you love most about them?","An inside joke or detail only you two share","What they mean to you — and why now"],
      partner:["How did you two meet?","What do you love most about them?","An inside joke or detail only you two share","What they mean to you — and why now"],
      parent:["A memory that says who they are","What did they always say or do?","Something they taught you, or a family saying","What they mean to you — and why now"],
      child:["A moment with them you’ll never forget","What are they like? (their quirks)","A nickname, or something only your family knows","Your hopes for them — and why this song now"],
      friend:["How did you become friends?","What makes them a great friend?","An inside joke or a story you both retell","What their friendship means to you"],
      pet:["How did they come into your life?","What are they like? (their funny habits)","What you call them, or a quirk only you’d know","What they mean to you — and why now"],
      memorial:["A memory that captures who they were","What were they like?","Something they always said or did","What they meant to you — and what you miss most"],
      other:["A favorite memory with them","What are they like?","A nickname, inside joke, or detail only you’d know","What they mean to you — and why now"]
    };
    // occasion → optional milestone field + a sensible default relationship
    var OCC = {
      anniversary:{rel:"spouse", ms:{label:"Which anniversary?", type:"select", opts:["Choose…","1st (paper)","5th (wood)","10th (tin)","25th (silver)","40th (ruby)","50th (gold)","Another year"]}},
      birthday:{rel:"friend"},
      wedding:{rel:"spouse", ms:{label:"Wedding date", type:"date"}},
      retirement:{rel:"parent", ms:{label:"Years of service (or what they’re retiring from)", type:"text", ph:"e.g., 30 years at the fire dept"}},
      graduation:{rel:"child", ms:{label:"What are they graduating from?", type:"text", ph:"e.g., high school, nursing school"}},
      "valentine's day":{rel:"partner"}, "mother's day":{rel:"parent"}, "father's day":{rel:"parent"},
      memorial:{rel:"memorial"}, christmas:{rel:"friend"}, "thank you":{rel:"friend"},
      "just because":{rel:"partner"}, other:{rel:"other"}
    };
    // mood follows the relationship (overridable by the visitor)
    var MOOD = { spouse:"romantic", partner:"romantic", parent:"nostalgic", child:"happy", friend:"upbeat", pet:"happy", memorial:"emotional", other:"emotional" };

    // Angle-PDP intent sets — recipient label + 4 story prompts (+ placeholders) +
    // optional story-section subtitle. Selected per product via data-form-intent (a
    // product metafield custom.form_intent). data-form-prompts (metafield
    // custom.form_prompts, newline-separated) can override the prompt LABELS free-form.
    // When neither attribute is present the relationship-adaptive defaults above run
    // unchanged, so every non-angle page (custom-song, occasion modals, plaque) is
    // untouched. Pride angles keep using pride MODE (data-pride), not an intent set.
    var FORM_INTENTS = {
      "drive-safe":{
        recipient:"Who's heading out the door?",
        sub:"Tell us about them and the goodbye you always say — we'll build the song around it.",
        prompts:["Who are they to you, and where are they driving off to?","What do you always say before they leave?","A memory from the driveway, the porch, the goodbye","What you want them to feel every time it plays"],
        phs:["my granddaughter, leaving for college in Ohio","text me when you get home","she still beeps twice pulling out of the drive","that home is always right behind them"],
        hide:["occasion","mood"], occasion:"Drive Safe", mood:"nostalgic"
      },
      "memorial":{
        recipient:"Who are we remembering?",
        sub:"Tell us about them — a few words for each is enough, or leave a voice note.",
        prompts:["A memory that captures who they were","What were they like?","Something they always said or did","What they meant to you — and what you miss most"],
        phs:["long porch talks, his old guitar","gentle, stubborn, always singing","signed every note 'love, Pop'","the man who taught me everything"]
      },
      "kids-birthday":{
        recipient:"Whose birthday is it?",
        sub:"Tell us about the birthday kid — a few words for each is enough.",
        prompts:["How old are they turning, and what are they into right now?","A moment with them you'll never forget","What are they like? (their quirks)","What you want them to feel on their day"],
        phs:["turning 7, obsessed with dinosaurs","the day she learned to ride her bike","fearless, silly, terrible at hiding","how loved they are"],
        hide:["occasion","mood"], occasion:"Birthday", mood:"happy"
      },
      "apology":{
        recipient:"Who are you apologizing to?",
        sub:"Tell us who you hurt and what you wish you'd said — a few words for each is enough, or leave a voice note.",
        prompts:["Who are you saying sorry to, and what are they to you?","What happened — what are you sorry for?","What do they mean to you, in your words?","How do you want to make it right?"],
        phs:["my wife Sarah — my best friend of 20 years","I put work first and kept letting her down","she's the calm in every storm I've caused","show her I've changed, not just say it"],
        hide:["occasion","mood"], occasion:"Apology", mood:"emotional"
      }
    };

    function val(el) { return el ? (el.value || '').trim() : ''; }
    function urlp(k) { try { return new URLSearchParams(window.location.search).get(k) || ''; } catch (e) { return ''; } }
    function setSel(sel, v) { if (!sel || !v) return false; v = String(v).toLowerCase(); for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value.toLowerCase() === v) { sel.selectedIndex = i; return true; } } return false; }

    function wire(root) {
      if (root.__sbWired) return;
      root.__sbWired = true;

      var rel = root.querySelector('[data-rel]');
      var occ = root.querySelector('[data-occ]');
      var msWrap = root.querySelector('[data-milestone-wrap]');
      var msLabel = root.querySelector('[data-milestone-label]');
      var msControl = root.querySelector('[data-milestone-control]');
      var moodSel = root.querySelector('[data-k="Song Mood"]');
      var userSetMood = false;
      setSel(rel, (root.getAttribute('data-ctx-rel') || '') || urlp('relationship') || urlp('rel'));
      setSel(occ, (root.getAttribute('data-ctx-occ') || '') || urlp('occasion') || urlp('occ'));

      // Angle-PDP intent: a named set (data-form-intent) and/or a free-form prompt
      // override (data-form-prompts, "|"-separated). Both absent → customPrompts is
      // null and applyRel behaves exactly as before.
      var intentKey = (root.getAttribute('data-form-intent') || '').toLowerCase();
      var intent = FORM_INTENTS[intentKey] || null;
      var promptsAttr = root.getAttribute('data-form-prompts') || '';
      var customPrompts = promptsAttr ? promptsAttr.split('|') : (intent ? intent.prompts : null);
      var intentPhs = intent ? intent.phs : null;
      if (intent) {
        var recIn = root.querySelector('[data-k="Recipient Name"]');
        var recLabel = recIn ? root.querySelector('label[for="' + recIn.id + '"]') : null;
        if (recLabel && intent.recipient) recLabel.innerHTML = intent.recipient + '<span class="sb-brief__req" aria-hidden="true">*</span>';
        var subEl = root.querySelector('.sb-brief__cardsub');
        if (subEl && intent.sub) subEl.textContent = intent.sub;
      }

      // Per-intent field visibility. data-form-hide (metafield custom.form_hide,
      // comma-separated) overrides the intent's hide list. Hidden fields still
      // submit sensible defaults so fulfillment loses no data. Absent → nothing
      // hidden → today's full field set.
      var hideAttr = (root.getAttribute('data-form-hide') || '').toLowerCase();
      var hideSet = hideAttr ? hideAttr.split(',') : (intent && intent.hide ? intent.hide : null);
      if (hideSet) {
        var hideWrap = function (el, sel) {
          var w = el && el.closest(sel || '.sb-brief__field'); if (!w) return; w.style.display = 'none';
          var row = w.closest('.sb-brief__two');
          if (row) { var shown = 0; row.querySelectorAll('.sb-brief__field').forEach(function (f) { if (f.style.display !== 'none') shown++; }); if (shown <= 1) row.style.gridTemplateColumns = '1fr'; }
        };
        hideSet.forEach(function (raw) {
          var key = (raw || '').trim();
          if (key === 'occasion') {
            hideWrap(occ);
            if (msWrap) msWrap.hidden = true;
            var occVal = (intent && intent.occasion) || (root.getAttribute('data-ctx-occ') || '');
            if (occ) occ.removeAttribute('data-k');
            if (occVal) { var oi = document.createElement('input'); oi.type = 'hidden'; oi.setAttribute('data-k', 'Occasion'); oi.value = occVal; root.appendChild(oi); }
          } else if (key === 'milestone') {
            if (msWrap) msWrap.hidden = true;
          } else if (key === 'mood') {
            hideWrap(moodSel);
            if (moodSel && intent && intent.mood) setSel(moodSel, intent.mood);
            userSetMood = true;
          } else if (key === 'relationship') {
            hideWrap(rel);
          } else if (key === 'style') {
            hideWrap(root.querySelector('[data-k="Music Style"]'));
          } else if (key === 'voice') {
            hideWrap(root.querySelector('[data-k="Singer Preference"]'));
          } else if (key === 'mentions') {
            hideWrap(root.querySelector('[data-k="Special Mentions"]'), '.sb-brief__prompt');
          } else if (key === 'voicenote') {
            var vn = root.querySelector('[data-voice]'); if (vn) vn.style.display = 'none';
          }
        });
      }

      function applyRel() {
        var r = rel ? rel.value : 'other', qs = customPrompts || QMAP[r] || QMAP.other;
        root.querySelectorAll('.sb-brief__pl[data-q]').forEach(function (l) { var s = parseInt(l.getAttribute('data-q'), 10); if (qs[s]) l.textContent = qs[s]; });
        if (customPrompts) {
          root.querySelectorAll('.sb-brief__pin[data-slot]').forEach(function (i) { var s = parseInt(i.getAttribute('data-slot'), 10); i.setAttribute('placeholder', (intentPhs && intentPhs[s]) ? intentPhs[s] : ''); });
        } else {
          var ex = REL[r] || REL.other;
          root.querySelectorAll('[data-ex]').forEach(function (i) { var k = i.getAttribute('data-ex'); if (ex[k] !== undefined) i.setAttribute('placeholder', ex[k]); });
        }
        var moodPick = MOOD[r];
        if (occ && (occ.value || '').toLowerCase() === 'memorial') { moodPick = 'emotional'; }
        if (moodSel && !userSetMood && moodPick) { setSel(moodSel, moodPick); }
      }
      var sbbPride = root.getAttribute('data-pride') === '1';

      function buildMilestone() {
        if (!msWrap) return;
        var cfg = OCC[(occ && occ.value ? occ.value : '').toLowerCase()];
        if (!cfg || !cfg.ms) { msWrap.hidden = true; if (msControl) msControl.innerHTML = ''; return; }
        msWrap.hidden = false;
        if (msLabel) msLabel.textContent = cfg.ms.label;
        var fid = (msLabel && msLabel.getAttribute('for')) || (root.id + '-ms');
        var html;
        if (cfg.ms.type === 'select') {
          html = '<select class="sb-brief__sel sb-brief__sel--ms" id="' + fid + '" data-k="Milestone">';
          cfg.ms.opts.forEach(function (o, i) { html += '<option value="' + (i === 0 ? '' : o) + '">' + o + '</option>'; });
          html += '</select>';
        } else if (cfg.ms.type === 'date') {
          html = '<input class="sb-brief__in" id="' + fid + '" type="date" data-k="Milestone">';
        } else {
          html = '<input class="sb-brief__in" id="' + fid + '" type="text" data-k="Milestone" placeholder="' + (cfg.ms.ph || '') + '">';
        }
        if (msControl) msControl.innerHTML = html;
      }

      if (!sbbPride) {
        var userSetRel = false;
        if (rel) { rel.addEventListener('change', function () { userSetRel = true; applyRel(); }); }
        if (moodSel) { moodSel.addEventListener('change', function () { userSetMood = true; }); }
        if (occ) { occ.addEventListener('change', function () {
          buildMilestone();
          if (!userSetRel) { var cfg = OCC[(occ.value || '').toLowerCase()]; if (cfg && cfg.rel) { setSel(rel, cfg.rel); } }
          applyRel();
        }); }
        buildMilestone();
        applyRel();
      }

      // voice: attach + record
      var voiceBlob = null, voiceName = null;
      var vfile = root.querySelector('[data-vfile]'), vstatus = root.querySelector('[data-vstatus]');
      var vbox = root.querySelector('[data-voice]'), vrec = root.querySelector('[data-vrec]');
      function setStatus(txt, cls) { if (!vstatus) return; vstatus.textContent = txt; vstatus.className = 'sb-brief__vstatus' + (cls ? ' ' + cls : ''); }
      if (vfile) vfile.addEventListener('change', function () { if (vfile.files && vfile.files[0]) { voiceBlob = vfile.files[0]; voiceName = vfile.files[0].name; setStatus('✓ Attached: ' + voiceName, 'is-on'); } });
      var canRec = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder);
      if (vrec && canRec) {
        vrec.hidden = false;
        var mr = null, chunks = [], recState = 'idle', secs = 0, timer = null, stream = null;
        var recLabel = root.querySelector('[data-vrec-label]');
        function fmt(s) { return Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60); }
        vrec.addEventListener('click', function () {
          if (recState === 'idle') {
            navigator.mediaDevices.getUserMedia({ audio: true }).then(function (s) {
              stream = s; chunks = []; mr = new MediaRecorder(s);
              mr.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
              mr.onstop = function () { voiceBlob = new Blob(chunks, { type: (mr.mimeType || 'audio/webm') }); voiceName = 'voice-note.webm'; if (stream) { stream.getTracks().forEach(function (t) { t.stop(); }); } setStatus('✓ Voice note recorded · ' + fmt(secs), 'is-on'); };
              mr.start(); recState = 'rec'; secs = 0; vbox.setAttribute('data-state', 'rec'); if (recLabel) recLabel.textContent = 'Stop'; setStatus('● Recording 0:00', 'is-rec');
              timer = setInterval(function () { secs++; setStatus('● Recording ' + fmt(secs), 'is-rec'); }, 1000);
            }).catch(function () { setStatus('Mic unavailable — attach a file instead', ''); });
          } else if (recState === 'rec') {
            recState = 'idle'; if (timer) clearInterval(timer); vbox.setAttribute('data-state', 'idle'); if (recLabel) recLabel.textContent = 'Re-record'; try { mr.stop(); } catch (e) {}
          }
        });
      }

      // API for the host's add-to-cart
      root.sbBrief = {
        validate: function () {
          var name = root.querySelector('[data-k="Recipient Name"]');
          if (!val(name)) { if (name) { try { name.focus(); } catch (e) {} } return 'Please add who the song is for.'; }
          var hasStory = false, firstEmpty = null;
          root.querySelectorAll('[data-slot]').forEach(function (i) { if (val(i)) hasStory = true; else if (!firstEmpty) firstEmpty = i; });
          if (!hasStory && !voiceBlob) { if (firstEmpty) { try { firstEmpty.focus(); } catch (e) {} } return 'Tell us a little of your story, or add a voice note.'; }
          return '';
        },
        collect: function () {
          var props = {};
          root.querySelectorAll('[data-k]').forEach(function (i) { var v = val(i); if (v) props[i.getAttribute('data-k')] = v; });
          var storyParts = [];
          root.querySelectorAll('[data-slot]').forEach(function (i) {
            var v = val(i);
            if (v) { var lbl = root.querySelector('.sb-brief__pl[data-q="' + i.getAttribute('data-slot') + '"]'); storyParts.push((lbl ? lbl.textContent : 'Story') + ': ' + v); }
          });
          if (storyParts.length) props['Story Details'] = storyParts.join('\n');
          return props;
        },
        getVoice: function () { return voiceBlob ? { blob: voiceBlob, name: voiceName || 'voice-note.webm' } : null; }
      };
    }

    function initAll() { document.querySelectorAll('[data-song-brief]').forEach(wire); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    window.sbBriefInit = initAll;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-player"] && !Shopify.designMode) return;
  try {
    // song-player — one behavior for every .sb-player on the page.
  // Real <audio> play/pause/seek/keyboard; progress painted by setting --p on the
  // track (its background gradient does the rest). Idempotent: safe to call again
  // (window.sbPlayerInit) for late/AJAX-injected players.
  (function () {
    if (window.__sbPlayerInit) return;
    window.__sbPlayerInit = true;

    function fmt(s) {
      s = Math.max(0, Math.floor(s || 0));
      var m = Math.floor(s / 60), ss = s % 60;
      return m + ':' + (ss < 10 ? '0' : '') + ss;
    }
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function wire(root) {
      if (root.__sbWired) return;
      root.__sbWired = true;

      var audio = root.querySelector('.sb-player__audio');
      var btn = root.querySelector('.sb-player__play');
      var track = root.querySelector('.sb-player__track');
      var cur = root.querySelector('.sb-player__cur');
      var dur = root.querySelector('.sb-player__dur');
      if (!audio || !track) return;
      var title = root.getAttribute('data-title') || 'song';

      function paint(p) {
        p = clamp(p, 0, 1);
        track.style.setProperty('--p', (p * 100).toFixed(2) + '%');
        track.setAttribute('aria-valuenow', String(Math.round(p * 100)));
      }

      if (btn) {
        btn.addEventListener('click', function () {
          if (audio.paused) {
            document.querySelectorAll('.sb-player__audio').forEach(function (o) { if (o !== audio) o.pause(); });
            audio.play().catch(function () { /* swallow autoplay rejections */ });
          } else {
            audio.pause();
          }
        });
      }

      audio.addEventListener('play', function () {
        root.setAttribute('data-playing', '');
        if (btn) btn.setAttribute('aria-label', 'Pause ' + title);
      });
      audio.addEventListener('pause', function () {
        root.removeAttribute('data-playing');
        if (btn) btn.setAttribute('aria-label', 'Play ' + title);
      });
      audio.addEventListener('ended', function () {
        root.removeAttribute('data-playing');
        paint(0);
        if (cur) cur.textContent = '0:00';
      });
      audio.addEventListener('loadedmetadata', function () {
        if (dur && isFinite(audio.duration)) dur.textContent = fmt(audio.duration);
      });
      audio.addEventListener('timeupdate', function () {
        var d = audio.duration || 0;
        paint(d > 0 ? audio.currentTime / d : 0);
        if (cur) cur.textContent = fmt(audio.currentTime);
      });

      function seekX(clientX) {
        var r = track.getBoundingClientRect();
        var f = clamp((clientX - r.left) / r.width, 0, 1);
        if (isFinite(audio.duration) && audio.duration > 0) {
          audio.currentTime = f * audio.duration;
          paint(f);
          if (cur) cur.textContent = fmt(audio.currentTime);
        }
      }
      var dragging = false;
      track.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        seekX(e.clientX);
      });
      track.addEventListener('pointermove', function (e) { if (dragging) seekX(e.clientX); });
      track.addEventListener('pointerup', function () { dragging = false; });
      track.addEventListener('pointercancel', function () { dragging = false; });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime + 5, 0, audio.duration);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          if (isFinite(audio.duration)) audio.currentTime = clamp(audio.currentTime - 5, 0, audio.duration);
        } else if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          if (btn) btn.click();
        }
      });

      paint(0);
    }

    function initAll() {
      var nodes = document.querySelectorAll('.sb-player');
      for (var i = 0; i < nodes.length; i++) wire(nodes[i]);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    window.sbPlayerInit = initAll;
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["song-quiz"] && !Shopify.designMode) return;
  try {
    // song-quiz — v6, 2026-09-22 (ADR-106). THE APP'S QUIZ, ON SHOPIFY.
  //
  // Every question, list, ordering and word comes from assets/sb-quiz-engine.js,
  // which IS the app's own lib/preview/quiz2.ts + app/_white/quiz/data.ts with the
  // types removed. Nothing here restates a question. If the app's wording changes,
  // recompile that file; do not edit copy in this snippet.
  //
  // Screens, in the app's order (SCREENS + PHASES from the engine):
  //   relationship · callname · occasion · sound · traits · memory · review
  //
  // UNCHANGED ON PURPOSE — the host section's add-to-cart depends on it:
  //   root.sbBrief.validate() / collect() / getVoice()
  //   properties: Recipient Name · Relationship · Occasion · Genre · Mood ·
  //               Singer Preference · Story
  // Story is built by the ENGINE's own assembleStory(), so the text the writer
  // receives from a Shopify order reads exactly like one from the app.
  (function () {
    if (window.__sbQuizInit) return;
    window.__sbQuizInit = true;

    function boot() {
      var E = window.SBQ_ENGINE;
      if (!E) return false;

      function esc(s) { return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
      // Shopify is PAY-FIRST, so the app's "Free to hear · Pay only if you love it"
      // would be untrue here. This is the store's own promise, matching the FAQ
      // ("100% money-back guarantee. Unlimited re-dos") word for word.
      var REASSURE = "100% money-back guarantee";
      var SCREENS = E.SCREENS.concat(["review"]);
      var STEPS = SCREENS.length;

      function wire(root) {
        if (root.__sbqWired) return;
        root.__sbqWired = true;
        root.__sbWired = true;

        var S = { step: 0, rel: "", relOther: "", from: "", name: "", pron: "", occ: "", occOther: false,
                  genre: "", mood: "", voice: "", traits: [], prompts: {}, story: "", message: "" };
        var STORE_KEY = "sbq3_draft";

        try {
          if (/[?&]another=1(&|$)/.test(window.location.search)) {
            sessionStorage.setItem("sbq_another", "1");
            sessionStorage.removeItem(STORE_KEY);
            if (window.history && history.replaceState) history.replaceState(null, "", window.location.pathname);
          }
        } catch (e) {}

        // ---- deep link (unchanged contract: ?name=&occasion=&rel=&offer=&step=) ----
        function mapRel(raw) {
          if (!raw) return "";
          var v = String(raw).trim().toLowerCase();
          for (var i = 0; i < E.REL_CHIPS.length; i++) if (E.REL_CHIPS[i].toLowerCase() === v) return E.REL_CHIPS[i];
          var SYN = { spouse: "Husband", partner: "Partner", mother: "Mom", mum: "Mom", mommy: "Mom",
                      father: "Dad", daddy: "Dad", papa: "Dad", bestfriend: "Friend", "best friend": "Friend", bff: "Friend",
                      me: "Myself", self: "Myself", grandmother: "Grandma", nana: "Grandma", grandfather: "Grandpa" };
          return SYN[v] || "";
        }
        function mapOcc(raw) {
          if (!raw) return null;
          var v = String(raw).trim();
          var SYN = { memorial: "In Memory", funeral: "In Memory", sympathy: "In Memory", "pet memorial": "In Memory", "any occasion": "", other: "" };
          var k = v.toLowerCase();
          if (Object.prototype.hasOwnProperty.call(SYN, k)) { v = SYN[k]; if (!v) return null; }
          for (var i = 0; i < E.ALL_OCCASIONS.length; i++) if (E.ALL_OCCASIONS[i].toLowerCase() === v.toLowerCase()) return { label: E.ALL_OCCASIONS[i], custom: false };
          return v ? { label: v.slice(0, 40), custom: true } : null;
        }
        var DEEP = null;
        try {
          var qp = new URLSearchParams(window.location.search);
          if (qp.has("name") || qp.has("occasion") || qp.has("rel") || qp.has("offer")) {
            DEEP = { name: (qp.get("name") || "").trim().slice(0, 40), rel: mapRel(qp.get("rel")),
                     occ: mapOcc(qp.get("occasion")), step: parseInt(qp.get("step") || "0", 10) || 0,
                     offer: (function (o) { return o === "song-plaque" || o === "song-soundbox" || o === "song" ? o : ""; })(qp.get("offer")) };
            if (DEEP.offer) { try { sessionStorage.setItem("sbq_offer", DEEP.offer); } catch (e) {} }
            if (DEEP.name || DEEP.rel || DEEP.occ) { try { sessionStorage.removeItem(STORE_KEY); } catch (e) {} }
          }
        } catch (e) { DEEP = null; }

        try {
          var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || "null");
          if (saved && typeof saved === "object") {
            ["rel", "relOther", "from", "name", "pron", "occ", "genre", "mood", "voice", "story", "message"].forEach(function (k) { if (typeof saved[k] === "string") S[k] = saved[k]; });
            if (Array.isArray(saved.traits)) S.traits = saved.traits.slice(0, 12);
            if (saved.prompts && typeof saved.prompts === "object") S.prompts = saved.prompts;
            if (E.REL_CHIPS.indexOf(S.rel) === -1) S.rel = "";
            S.occOther = !!saved.occOther && !!S.occ;
            if (S.voice && !E.VOICE_VALUE[S.voice]) S.voice = "";
            if (typeof saved.step === "number") S.step = Math.max(0, Math.min(STEPS - 1, saved.step));
          }
        } catch (e) {}

        if (!DEEP) {
          var seedRel = mapRel(root.getAttribute("data-seed-rel"));
          var seedOcc = mapOcc(root.getAttribute("data-seed-occ"));
          var unconfirmed = S.step === 0;
          if (seedRel && (!S.rel || unconfirmed)) { S.rel = seedRel; S.relOther = ""; }
          if (root.hasAttribute("data-seed-occ") && (!S.occ || unconfirmed)) {
            S.occ = seedOcc ? seedOcc.label : ""; S.occOther = seedOcc ? seedOcc.custom : false;
          }
        }
        if (DEEP) {
          if (DEEP.rel) S.rel = DEEP.rel;
          if (DEEP.name) S.name = DEEP.name;
          if (DEEP.occ) { S.occ = DEEP.occ.label; S.occOther = DEEP.occ.custom; }
          var reach = 0;
          if (S.rel) reach = 1;
          if (reach === 1 && S.name.trim()) reach = 2;
          if (reach === 2 && S.occ.trim()) reach = 3;
          S.step = Math.max(0, Math.min(DEEP.step, reach, STEPS - 1));
          try { if (window.history && history.replaceState) history.replaceState(null, "", window.location.pathname); } catch (e) {}
        }

        function persist() {
          try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ step: S.step, rel: S.rel, relOther: S.relOther, from: S.from, name: S.name, pron: S.pron, occ: S.occ, occOther: S.occOther, genre: S.genre, mood: S.mood, voice: S.voice, traits: S.traits, prompts: S.prompts, story: S.story, message: S.message })); } catch (e) {}
        }
        if (DEEP) persist();

        // The frame must be exactly one screen minus whatever site chrome sits above it.
        (function fitToScreen() {
          function measure() {
            var hdr = document.querySelector(".sbh") || document.querySelector("header");
            var h = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
            root.style.setProperty("--sbq-head-h", h + "px");
          }
          measure();
          window.addEventListener("resize", measure);
          window.addEventListener("orientationchange", measure);
        })();

        var backBtn = root.querySelector("[data-sbq-back]");
        var countEl = root.querySelector("[data-sbq-count]");
        var barWrap = root.querySelector("[data-sbq-barwrap]");
        var barEl = root.querySelector("[data-sbq-bar]");
        var screenEl = root.querySelector("[data-sbq-screen]");
        var nextBtn = root.querySelector("[data-sbq-next]");
        var errEl = root.querySelector("[data-error]");

        // ---- everything below ASKS THE ENGINE; nothing is restated here ----
        function occKey() { return S.occOther ? "Just Because" : (S.occ || "Just Because"); }
        function nameOr() { return S.name.trim() || "them"; }
        function nameCfg() { return E.callNameConfig(S.rel || "Friend"); }
        // The app lists EVERY style, the recommended ones first. Verified on
        // app.songbond.com/create/v2 2026-09-22: Daughter + Birthday renders
        // Pop, Acoustic, Country, Soul, then Gospel, R&B, Rock, Jazz, Folk,
        // Blues — i.e. recommendedStyles() followed by the rest of ALL_STYLES.
        function styles() {
          var rec = E.recommendedStyles(S.rel || "Friend", occKey());
          return rec.concat(E.ALL_STYLES.filter(function (g) { return rec.indexOf(g) < 0; }));
        }
        function moods() { return E.moodOptions(S.rel || "Friend", occKey()); }
        function traitList() { return E.KID && E.KID.has(S.rel) ? E.universalKidTraits() : E.traitsFor(S.rel || "Friend", occKey()); }
        function promptList() { return E.storyPrompts(S.rel || "Friend", occKey(), nameOr()); }
        function memorial() { return occKey() === "In Memory"; }
        function phase() { return E.PHASES[SCREENS[S.step]] || { name: "" }; }

        function canContinue() {
          switch (SCREENS[S.step]) {
            case "relationship": return !!S.rel && (S.rel !== "Someone else" || !!S.relOther.trim());
            case "callname": return S.name.trim().length > 0;
            case "occasion": return !!S.occ.trim();
            case "sound": return !!S.genre && !!S.mood && !!S.voice;
            case "traits": return S.traits.length > 0;
            case "memory": return S.story.trim().length > 0;
            default: return true;
          }
        }
        function nextLabel() {
          if (SCREENS[S.step] === "review") return "Looks right";
          if (SCREENS[S.step] === "memory" && !canContinue()) return "Write one thing";
          return "Continue";
        }

        // The app renders EVERY choice as a card in a two-column grid with a tick
        // on the selected one (.qz-opt in .qz-grid) — never as a pill. Verified
        // against app.songbond.com/create/v2 on 2026-09-22: steps 1, 3 and 4 are
        // all 2-column grids, 0 pills. `chip` is kept only for the small quick-pick
        // rows (call-name, who-it's-from), which ARE pills in the app.
        var TICK = '<svg class="sbq-tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
        function opt(act, val, label, sub, sel) {
          return '<button type="button" class="sbq-card" data-a="' + act + '" data-v="' + esc(val) + '" aria-pressed="' + (sel ? "true" : "false") + '">'
            + '<span><span class="sbq-card__l">' + esc(label) + '</span>' + (sub ? '<span class="sbq-card__s">' + esc(sub) + '</span>' : '') + '</span>' + TICK + '</button>';
        }
        function grid(items) { return '<div class="sbq-grid">' + items.join("") + '</div>'; }
        // The app's .qz-picked row + .qz-group wrapper.
        function picked(k, v, what) {
          return '<div class="sbq-picked"><span><span class="sbq-picked__k">' + esc(k) + '</span>'
            + '<span class="sbq-picked__v">' + esc(v) + '</span></span>'
            + '<button type="button" class="sbq-link" data-a="unpick" data-v="' + esc(what) + '">Change</button></div>';
        }
        function group(title, inner) {
          return '<div class="sbq-group"><h2 class="sbq-group__t">' + esc(title) + '</h2>' + inner + '</div>';
        }
        var fromOwn = false;
        function chip(act, val, label, sel, cls) {
          return '<button type="button" class="sbq-chip' + (cls ? " " + cls : "") + '" data-a="' + act + '" data-v="' + esc(val) + '" aria-pressed="' + (sel ? "true" : "false") + '">' + esc(label) + '</button>';
        }

        function render() {
          var n = S.step + 1;
          countEl.textContent = n + " of " + STEPS;
          countEl.setAttribute("aria-label", "Step " + n + " of " + STEPS);
          var pct = Math.round((n / STEPS) * 100);
          barWrap.setAttribute("aria-valuenow", String(pct));
          barEl.style.width = pct + "%";
          backBtn.setAttribute("aria-label", S.step === 0 ? "Back to the homepage" : "Back");

          var scr = SCREENS[S.step], h = '<div class="sbq-hd sbq-in"><p class="sbq-phase">' + esc(phase().name) + '</p>';

          if (scr === "relationship") {
            h += '<p class="sbq-reassure">'
              + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>'
              + esc(REASSURE) + '</p>'
              + '<h2 class="sbq-h2">Who’s this song for?</h2></div>';
            var fc = S.rel ? E.fromChips(S.rel) : [];
            // Answered -> the 22-card grid is gone, replaced by the picked line.
            if (S.rel && (fc.length || S.rel === "Someone else")) { h += picked("For", S.rel, "rel"); }
            else { h += grid(E.REL_CHIPS.map(function (r) { return opt("rel", r, r, "", S.rel === r); })); }
            if (fc.length) {
              var own = fromOwn || (!!S.from && fc.indexOf(S.from) < 0);
              h += '<div class="sbq-from"><p class="sbq-label">Who’s it from?</p>'
                + '<div class="sbq-chips sbq-chips--quick">'
                + fc.map(function (f) { return chip("from", f, f, !own && S.from === f, "sbq-chip--sm"); }).join("")
                + chip("fromown", "__type", "Type your own", own, "sbq-chip--sm") + '</div>'
                + (own ? '<input class="sbq-input sbq-input--sm" data-f="from" maxlength="40" placeholder="' + esc(E.fromPlaceholder(S.rel)) + '" value="' + esc(S.from) + '" aria-label="Who it’s from">' : "")
                + '</div>';
            }
            if (S.rel === "Someone else") {
              h += '<div class="sbq-from"><p class="sbq-label">Who are they to you?</p><input class="sbq-input sbq-input--sm" data-f="relOther" maxlength="40" placeholder="Sister-in-law, coach, teacher…" value="' + esc(S.relOther) + '" autocapitalize="words" aria-label="Who are they to you?"></div>';
            }
          } else if (scr === "callname") {
            var c = nameCfg();
            h += '<h2 class="sbq-h2">' + esc(c.title) + '</h2><p class="sbq-sub">' + esc(c.sub) + '</p></div>'
              + '<div class="sbq-name">'
              + (c.quick && c.quick.length ? '<p class="sbq-q">Quick picks</p><div class="sbq-chips sbq-chips--quick">' + c.quick.map(function (q) { return chip("quick", q, q, S.name.trim() === q, "sbq-chip--sm"); }).join("") + '</div>' : "")
              + '<input class="sbq-input" data-f="name" placeholder="' + esc(c.placeholder) + '" value="' + esc(S.name) + '" autocapitalize="words" autocomplete="off" aria-label="' + esc(c.title) + '">'
              + '<p class="sbq-hint">This is the name the song sings.</p></div>';
          } else if (scr === "occasion") {
            var order = E.occasionOrder(S.rel || "Friend");
            h += '<h2 class="sbq-h2">What’s the occasion?</h2></div>'
              + grid(order.map(function (o) { return opt("occ", o, o, "", !S.occOther && S.occ === o); })
                     .concat([opt("occ", E.OCC_OTHER_LABEL, E.OCC_OTHER_LABEL, "", S.occOther)]));
            if (S.occOther) {
              h += '<div class="sbq-name"><p class="sbq-q">What are we celebrating?</p><input class="sbq-input sbq-input--sm" data-f="occCustom" maxlength="60" placeholder="Engagement party, homecoming, new job…" value="' + esc(S.occ) + '" aria-label="Your occasion"></div>';
            }
          } else if (scr === "sound") {
            // The app reveals ONE group at a time, in this order, each collapsing
            // into a picked line as it is answered: Style -> Feeling -> Voice.
            h += '<h2 class="sbq-h2">Music style, voice and mood</h2></div>';
            if (S.genre) { h += picked("Style", S.genre, "genre"); }
            if (S.mood) { h += picked("Feeling", S.mood, "mood"); }
            if (S.voice) { h += picked("Voice", S.voice, "voice"); }
            if (!S.genre) {
              h += group("Style", grid(styles().concat([E.SURPRISE]).map(function (g) { return opt("genre", g, g, "", false); })));
            } else if (!S.mood) {
              h += group("Feeling", grid(moods().concat([E.SURPRISE]).map(function (m) { return opt("mood", m, m, "", false); })));
            } else if (!S.voice) {
              // Voice is two options in the app — no "Surprise Me".
              h += group("Voice", grid(Object.keys(E.VOICE_VALUE).filter(function (v) { return v !== E.SURPRISE; }).map(function (v) { return opt("voice", v, v, "", false); })));
            }
          } else if (scr === "traits") {
            var tl = traitList();
            h += '<h2 class="sbq-h2">' + esc(memorial() ? "What were they like?" : E.TRAITS_SCREEN.title) + '</h2><p class="sbq-sub">' + esc(E.TRAITS_SCREEN.hint) + '</p></div>'
              + '<div class="sbq-chips">' + tl.map(function (t) { return chip("trait", t, t, S.traits.indexOf(t) >= 0); }).join("") + '</div>';
          } else if (scr === "memory") {
            // The app's step 6, verbatim in shape: one box, the worked example BELOW it,
            // then an optional message. It does NOT ask the prompt questions here.
            var who = S.name.trim() || "them";
            var pr = E.herHim(S.rel || "Friend") || "them";
            var sub = memorial()
              ? "A favorite memory, what made " + pr + " special, or what you\u2019d want to tell " + pr + "."
              : "A favorite memory, what makes " + pr + " special, or what you want " + pr + " to hear.";
            h += '<h2 class="sbq-h2">Tell us about ' + esc(who) + '</h2><p class="sbq-sub">' + esc(sub) + '</p></div>'
              + '<textarea class="sbq-ta sbq-ta--memory" data-f="story" rows="4" aria-label="Your story" placeholder="A few words are enough.">' + esc(S.story) + '</textarea>'
              + '<figure class="sbq-eg"><figcaption>For example</figcaption><p>\u201c' + esc(E.memoryExample(S.rel || "Friend", occKey())) + '\u201d</p></figure>'
              + '<details class="sbq-msg"' + (S.message.trim() ? " open" : "") + '>'
              + '<summary><span class="sbq-msg__plus" aria-hidden="true"></span>Add a message for ' + esc(who) + ' <small>(optional)</small></summary>'
              + '<textarea class="sbq-ta sbq-msg__box" data-f="message" rows="3" maxlength="1000" aria-label="Your message for ' + esc(who) + '" placeholder="' + esc(who + ", I wanted to tell you\u2026") + '">' + esc(S.message) + '</textarea>'
              + '</details>';
          } else {
            // The app's own review rows, in its order: For · From · Name · Occasion ·
            // Sound · Like them · Memory. A From row appears only when there IS a from —
            // a row for an answer nobody was asked reads as a bug.
            var rows = [["For", S.rel === "Someone else" ? (S.relOther.trim() || "Someone else") : S.rel, 0]];
            if (S.from.trim()) rows.push(["From", S.from.trim(), 0]);
            rows.push(["Name", S.name.trim(), 1]);
            rows.push(["Occasion", S.occ, 2]);
            rows.push(["Sound", [S.genre, S.mood, S.voice].filter(Boolean).join(" \u00b7 "), 3]);
            rows.push(["Like them", S.traits.join(", "), 4]);
            rows.push(["Memory", S.story.trim(), 5]);
            h += '<h2 class="sbq-h2">One quick check.</h2><p class="sbq-sub">Change anything before we start writing.</p></div>'
              + '<div class="sbq-rows">' + rows.map(function (r) { return '<button type="button" class="sbq-row" data-a="edit" data-v="' + r[2] + '"><span><span class="sbq-row__k">' + esc(r[0]) + '</span><span class="sbq-row__v">' + esc(r[1]) + '</span></span><span class="sbq-row__e">Edit</span></button>'; }).join("") + '</div>';
          }

          screenEl.innerHTML = h;
          syncFoot();
          wireScreen();
          persist();
        }

        var underEl = root.querySelector("[data-sbq-under]");
        var ARROW = ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
        function syncFoot() {
          nextBtn.innerHTML = esc(nextLabel()) + ARROW; /* the app shows the arrow disabled too */
          nextBtn.disabled = !canContinue();
          if (underEl) {
            var u = SCREENS[S.step] === "relationship" ? "You can change this later."
                  : SCREENS[S.step] === "memory" ? "Last question \u2014 then one quick check." : "";
            underEl.textContent = u; underEl.hidden = !u;
          }
        }
        function go(n) {
          S.step = Math.max(0, Math.min(STEPS - 1, n));
          if (errEl) errEl.hidden = true;
          render();
          try { window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.pageYOffset - 80), behavior: "smooth" }); } catch (e) {}
        }

        function wireScreen() {
          screenEl.querySelectorAll("[data-a]").forEach(function (el) {
            el.addEventListener("click", function () {
              var a = el.getAttribute("data-a"), v = el.getAttribute("data-v");
              // AUTO-ADVANCE (Ajinkya, 2026-09-22): the app moves on the moment a
              // single choice is made — it does not wait for Continue. Picking a
              // relationship that has a "who's it from?" question stays put so that
              // question can be answered; every other one goes straight on.
              // ⚠️ This is load-bearing: the app's own INS-111 records orders stopping
              // for fifteen minutes when a step-1 change cost the auto-advance.
              if (a === "unpick") {
                // "Change" reopens that question and clears the answers after it,
                // so exactly one group is ever open.
                if (v === "rel") { S.rel = ""; S.relOther = ""; S.from = ""; fromOwn = false; }
                else if (v === "genre") { S.genre = ""; S.mood = ""; S.voice = ""; }
                else if (v === "mood") { S.mood = ""; S.voice = ""; }
                else if (v === "voice") { S.voice = ""; }
                render(); return;
              }
              if (a === "fromown") {
                fromOwn = true; S.from = ""; render();
                var fi = screenEl.querySelector('[data-f="from"]'); if (fi) fi.focus();
                return;
              }
              if (a === "rel") {
                S.rel = v; S.from = ""; fromOwn = false;
                if (E.fromChips(v).length || v === "Someone else") { render(); }
                else { go(S.step + 1); }
                return;
              }
              if (a === "from") { S.from = v; fromOwn = false; go(S.step + 1); return; }
              if (a === "quick") { S.name = v; render(); return; }
              if (a === "occ") {
                if (v === E.OCC_OTHER_LABEL) { S.occOther = true; S.occ = ""; render(); var oc = screenEl.querySelector('[data-f="occCustom"]'); if (oc) oc.focus(); }
                else { S.occOther = false; S.occ = v; go(S.step + 1); }
                return;
              }
              // Style → Voice → Mood each advance as they are answered; the screen
              // itself moves on once all three are set.
              if (a === "genre" || a === "voice" || a === "mood") {
                if (a === "genre") S.genre = v; else if (a === "voice") S.voice = v; else S.mood = v;
                if (S.genre && S.voice && S.mood) { go(S.step + 1); }
                else { render(); }
                return;
              }
              if (a === "trait") {
                var i = S.traits.indexOf(v);
                if (i >= 0) S.traits.splice(i, 1); else if (S.traits.length < 12) S.traits.push(v);
                render(); return;
              }
              if (a === "edit") { go(parseInt(v, 10) || 0); return; }
            });
          });
          screenEl.querySelectorAll("input[data-f],textarea[data-f]").forEach(function (f) {
            f.addEventListener("input", function () {
              var k = f.getAttribute("data-f");
              if (k === "name") S.name = f.value;
              else if (k === "relOther") S.relOther = f.value;
              else if (k === "from") S.from = f.value;
              else if (k === "occCustom") S.occ = f.value;
              else if (k === "story") S.story = f.value;
              else if (k === "message") S.message = f.value;
              else if (k === "prompt") S.prompts[f.getAttribute("data-k")] = f.value;
              syncFoot(); persist();
            });
            if (f.tagName === "INPUT") f.addEventListener("keydown", function (e) { if (e.key === "Enter" && canContinue()) { e.preventDefault(); nextBtn.click(); } });
          });
        }

        backBtn.addEventListener("click", function () { if (S.step > 0) go(S.step - 1); else window.location.href = "/"; });

        var hostCs = root.closest(".cs");
        var submitting = false;
        if (errEl && "MutationObserver" in window) {
          new MutationObserver(function () { if (!errEl.hidden && submitting) { submitting = false; syncFoot(); } }).observe(errEl, { attributes: true, attributeFilter: ["hidden"] });
        }
        nextBtn.addEventListener("click", function () {
          if (!canContinue()) return;
          if (S.step < STEPS - 1) { go(S.step + 1); return; }
          if (submitting) return;
          var submit = hostCs ? hostCs.querySelector("[data-submit]") : null;
          if (submit) { submitting = true; nextBtn.disabled = true; nextBtn.textContent = "Adding…"; if (errEl) errEl.hidden = true; submit.click(); }
        });

        // ---- HOST API — unchanged shape, unchanged property names ----
        root.sbBrief = {
          validate: function () {
            var order = ["relationship", "callname", "occasion", "sound", "traits", "memory"];
            var msg = { relationship: "Tell us who the song is for.", callname: "What should the song call them?",
                        occasion: "Pick the occasion.", sound: "Pick a style, a voice and a mood.",
                        traits: "Pick a few words that describe them.", memory: "Write one true thing about " + nameOr() + "." };
            var here = S.step;
            for (var i = 0; i < order.length; i++) {
              S.step = SCREENS.indexOf(order[i]);
              if (!canContinue()) { go(S.step); return msg[order[i]]; }
            }
            S.step = here;
            return "";
          },
          collect: function () {
            var props = {};
            props["Recipient Name"] = S.name.trim();
            props["Relationship"] = S.rel === "Someone else" ? (S.relOther.trim() || "Someone else") : S.rel;
            props["Occasion"] = S.occ.trim();
            props["Genre"] = S.genre;
            props["Mood"] = S.mood;
            props["Singer Preference"] = S.voice === "Male voice" ? "Male" : S.voice === "Female voice" ? "Female" : "No preference";  /* Surprise Me / unset → no preference */
            // The ENGINE writes the story, so a Shopify order reads like an app order.
            var answered = promptList()
              .filter(function (p) { return (S.prompts[p.key] || "").trim(); })
              .map(function (p) { return { label: p.label, value: (S.prompts[p.key] || "").trim() }; });
            var story = E.assembleStory({ traits: S.traits, prompts: answered, story: S.story.trim(),
                                          memory: "", message: S.message.trim(), pronunciation: S.pron, name: S.name.trim() });
            if (story && story.trim()) props["Story"] = story.trim();
            if (S.from.trim()) props["From"] = S.from.trim();
            return props;
          },
          getVoice: function () { return null; }
        };

        render();
      }

      document.querySelectorAll("[data-song-quiz]").forEach(wire);
      window.sbQuizInit = function () { document.querySelectorAll("[data-song-quiz]").forEach(wire); };
      return true;
    }

    // The engine is a separate asset; wait for it rather than racing it.
    function start() { if (!boot()) { var t = setInterval(function () { if (boot()) clearInterval(t); }, 40); setTimeout(function () { clearInterval(t); }, 8000); } }
    if (document.readyState !== "loading") start();
    else document.addEventListener("DOMContentLoaded", start);
  })();
  } catch(e) { console.error(e); }
})();

})();
